import { Reducer } from 'redux';
import { Section } from 'src/store/sections/types';
import { SharedActionTypes } from '../shared/types';
import { arrayUnique } from './../../utils/sharedHelpers';
import { SectionActionTypes, SectionState } from './types';

const initialState: SectionState = {
  data: {
    byId: {},
    allIds: []
  },
  errors: undefined,
  loading: false
};

const reducer: Reducer<SectionState> = (state = initialState, action) => {
  switch (action.type) {
    case SectionActionTypes.FETCH_REQUEST: {
      return { ...state, loading: true };
    }
    case SectionActionTypes.FETCH_SUCCESS: {
      const newByTitle = {};
      const newAllTitles: string[] = [];

      if (Array.isArray(action.payload)) {
        const arr = action.payload.sort((sA: Section, sB: Section) => {
          if (!!sA.order_nr && !!sB.order_nr) {
            return sA.order_nr - sB.order_nr;
          } else {
            return sA.id - sB.id;
          }
        });
        console.log(arr);
        arr.forEach((el: Section) => {
          const formattedTitle = el.title.toLowerCase();
          newByTitle[formattedTitle] = el;
          newAllTitles.push(formattedTitle);
        });
      } else {
        const el = action.payload;
        const formattedTitle = el.title.toLowerCase();

        newByTitle[formattedTitle] = el;
        newAllTitles.push(formattedTitle);
      }

      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          byId: { ...state.data.byId, ...newByTitle },
          allIds: arrayUnique(state.data.allIds.concat(newAllTitles))
        }
      };
    }
    case SectionActionTypes.UPDATE_SECTION: {
      const { data, oldSectionTitle } = action.payload;

      const byId = { ...state.data.byId };

      const id = data.title.toLowerCase();

      delete byId[oldSectionTitle];

      let allIds = [...state.data.allIds];

      allIds = allIds.filter(title => {
        return title !== oldSectionTitle;
      });
      allIds.push(id);

      byId[id] = { ...byId[id], ...data };

      allIds.sort((a, b) => {
        const eA = byId[a];
        const eB = byId[b];

        if (!!eA.order_nr && !!eB.order_nr) {
          return eA.order_nr - eB.order_nr;
        } else {
          return eA.id - eB.id;
        }
      });

      return {
        ...state,
        data: {
          ...state.data,
          byId,
          allIds
        },
        loading: false
      };
    }
    case SectionActionTypes.CREATE_SECTION: {
      const { data } = action.payload;

      const byId = { ...state.data.byId };

      const id = data.title.toLowerCase();

      const allIds = [...state.data.allIds];
      allIds.push(id);

      byId[id] = { ...byId[id], ...data };

      allIds.sort((a, b) => {
        const eA = byId[a];
        const eB = byId[b];

        if (!!eA.order_nr && !!eB.order_nr) {
          return eA.order_nr - eB.order_nr;
        } else {
          return eA.id - eB.id;
        }
      });

      return {
        ...state,
        data: {
          ...state.data,
          byId,
          allIds
        },
        loading: false
      };
    }
    case SectionActionTypes.REMOVE_SECTION: {
      const sectionTitle = action.payload;

      const newById = { ...state.data.byId };

      delete newById[sectionTitle];

      const newAllid = [...state.data.allIds];
      newAllid.splice(newAllid.indexOf(sectionTitle), 1);

      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          byId: newById,
          allIds: newAllid
        }
      };
    }
    case SectionActionTypes.FETCH_ERROR: {
      return { ...state, loading: false, errors: action.payload };
    }
    case SharedActionTypes.RESET: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.ts` folder.
export { reducer as sectionReducer };



// WEBPACK FOOTER //
// ./src/store/sections/reducer.ts